import React from 'react';

import AssociationInput from './inputTypes/AssociationInput';
import CheckboxesInput from './inputTypes/CheckboxesInput';
import CheckboxInput from './inputTypes/CheckboxInput';
import DateInput from './inputTypes/DateInput';
import DateTimeInput from './inputTypes/DateTimeInput';
import DefaultInput from './inputTypes/DefaultInput';
import FileInput from './inputTypes/FileInput';
import HiddenInput from './inputTypes/HiddenInput';
import LocationInput from './inputTypes/LocationInput';
import NumberInput from './inputTypes/NumberInput';
import OTPInput from './inputTypes/OTPInput';
import PostalRangeInput from './inputTypes/PostalRangeInput';
import RadioGroup from './inputTypes/RadioGroup';
import RichTextInput from './inputTypes/RichTextInput';
import SearchInput from './inputTypes/SearchInput';
import SelectInput from './inputTypes/SelectInput';
import SliderInput from './inputTypes/SliderInput';
import ToggleGroup from './inputTypes/ToggleGroup';
import { InputRenderer, InputType } from './types';

const OmniInput = (props: InputRenderer & { type: InputType }) => {
  switch (props.type) {
    case InputType.Checkbox:
      return <CheckboxInput {...props} />;
    case InputType.Checkboxes:
      return <CheckboxesInput {...props} />;
    case InputType.Date:
      return <DateInput {...props} />;
    case InputType.DateTime:
      return <DateTimeInput {...props} />;
    case InputType.Description:
      return null;
    case InputType.File:
      return <FileInput {...props} />;
    case InputType.Hidden:
      return <HiddenInput {...props} />;
    case InputType.Number:
      return <NumberInput {...props} />;
    case InputType.Location:
      return <LocationInput {...props} />;
    case InputType.OTP:
      return <OTPInput {...props} />;
    case InputType.PostalRange:
      return <PostalRangeInput {...props} />;
    case InputType.RadioGroup:
      return <RadioGroup {...props} />;
    case InputType.Search:
      return <SearchInput {...props} />;
    case InputType.Select:
      return <SelectInput {...props} />;
    case InputType.TextArea:
      return <DefaultInput {...props} multiline />;
    case InputType.Text:
    case InputType.Email:
    case InputType.Password:
    case InputType.Telephone:
      return <DefaultInput {...props} />;
    case InputType.ToggleGroup:
      return <ToggleGroup {...props} />;
    case InputType.AssociationInput:
      return <AssociationInput {...props} />;
    case InputType.Slider:
      return <SliderInput {...props} />;
    case InputType.RichText:
      return <RichTextInput {...props} />;
  }
};

export default OmniInput;
